import { IPhoneFormControlOptions } from "../phone-form-control";
import { SubjectMapped } from "../types";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";

export class SSPhoneOptions implements Required<SubjectMapped<IPhoneFormControlOptions>> {

  constructor(
    private _initialOptions?: IPhoneFormControlOptions
  ) {

    this._initOptions();
  }


  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'phone'>(this, this._initialOptions);

  }

  dispose() {

  }
}
